
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Milk } from 'lucide-react';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-white border-t border-gray-100 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
          <div className="text-center md:text-left">
            <p className="text-xl font-bold text-[#0F172A] mb-1">
              rtneg<span className="text-[#3B82F6]">.com</span>
            </p>
            <p className="text-sm text-gray-400">
              {t('footer.copyright')}
            </p>
          </div>
          <div className="flex flex-wrap justify-center md:justify-end gap-6 md:gap-8 items-center">
            <a 
              href="https://buymeacoffee.com/rtneg" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-1.5 text-sm text-gray-500 hover:text-[#3B82F6] transition-colors"
            >
              <Milk className="w-3.5 h-3.5" />
              <span>{t('footer.support')}</span>
            </a>
            <a href="#" className="text-sm text-gray-500 hover:text-[#3B82F6] transition-colors">
              {t('footer.terms')}
            </a>
            <a href="#" className="text-sm text-gray-500 hover:text-[#3B82F6] transition-colors">
              {t('footer.privacy')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
